export default __webpack_public_path__ + "static/media/pg-9.ac70fbbb.jpg";